import React, { PropsWithChildren } from 'react'

import { DataAttribute } from '@frame/types'
import { Transition } from '@headlessui/react'

type Props = PropsWithChildren<{
  show: boolean
  hide: () => void
}>

export function SlideUpPopover({ children, show, hide }: Props) {
  return (
    <>
      <Transition
        data-cy={DataAttribute.SLIDE_UP_POPOVER_OVERLAY}
        show={show}
        as="div"
        enter="ease-out duration-200"
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave="ease-in duration-200"
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        className="absolute z-50 h-full w-full bg-black bg-opacity-60"
        onClick={hide}
      />
      <Transition
        show={show}
        as="div"
        enter="ease-out duration-200"
        enterFrom="opacity-0 translate-y-[264px]"
        enterTo="opacity-100 translate-y-0"
        leave="ease-in duration-200"
        leaveFrom="opacity-100 translate-y-0"
        leaveTo="opacity-0 translate-y-[264px]"
        className="absolute bottom-0 left-0 z-50 max-h-[calc(100%)] w-full overflow-y-auto rounded-t-lg bg-white p-5"
      >
        <div data-cy={DataAttribute.SLIDE_UP_POPOVER} className="flex flex-col">
          {children}
        </div>
      </Transition>
    </>
  )
}
